$(document).ready(function() {
  let locations = [];
  let markers = [];
  let coordinates = null;
  let map;
  let fitBounds = true;
  let zoomChangedEnabled = false;
  const infowindow = new google.maps.InfoWindow({
    pixelOffset: new google.maps.Size(0, -5),
  });

  const qs = (key) => {
    key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, '\\$&'); // escape RegEx meta chars
    var match = location.search.match(
      new RegExp('[?&]' + key + '=([^&]+)(&|$)'),
    );
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  };

  $('#find-search-location').val(qs('q'));
  $('#locationFilter').val(qs('locationFilter') === 'on' ? 'on' : 'off');

  const onCoordinatesUpdated = ({coordinates}) => {
    $('.find__preloader').show();
    $.ajax(`${window.moonshineApi}/locator`, {
      data: JSON.stringify({coordinates}),
      contentType: 'application/json',
      type: 'POST',
      success: function(response) {
        locations = (response || {}).location;
        onLocationsUpdate({locations});
        $('.find__preloader').hide();
      },
      error: function(xhr, status, error) {
        console.error(error);
      },
    });
  };

  $('.shopify-section').on('click', '.find__nearbyButton', function(e) {
    geolocator.locate(
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumWait: 10000,
        fallbackToIP: true,
      },
      (err, location) => {
        if (err) return console.log(err);
        coordinates = (location || {}).coords;
        const landmark = ((location || {}).address || {}).city;
        if (coordinates != null) {
          onCoordinatesUpdated({
            coordinates: {
              ...coordinates,
              locationFilter: $('#locationFilter').val(),
            },
          });
        }
        if (landmark != null) {
          $('#find-search-location').val(landmark);
        }
      },
    );
  });

  $('.find__form').submit(function(e) {
    e.preventDefault();
    fitBounds = true;
    const $this = $(this);
    const searchValue = $this.find('input[name=search]').val();
    window.location =
      '/pages/find-a-jar?q=' +
      encodeURIComponent(searchValue) +
      `&locationFilter=${$('#locationFilter').val()}`;
  });

  $('#locationFilter').change(function() {
    const $this = $(this);
    const locationFilter = $this.val() === 'on' ? 'on' : 'off';
    fitBounds = true;
    onCoordinatesUpdated({coordinates: {...coordinates, locationFilter}});
  });

  const renderList = ({locations}) => {
    const $list = $('.find__list');
    $list.empty();
    locations.forEach((loc, idx) => {
      const address = `${loc.street}, ${loc.city}, ${loc.state} ${loc.zip}`;
      const directionsUrl = `https://maps.google.com/?q=${encodeURIComponent(
        `${loc.street},${loc.city},${loc.state}`,
      )}`;
      const inventoryDetails = (loc.otherBrand || [])
        .map((brand) => {
          const lookupValue = findajarVars.productMap[brand];
          return lookupValue == null
            ? null
            : `
          <a class="find__storeDetailsProduct" href="${lookupValue.link}">
            <div class="find__storeDetailsProductImage ${lookupValue.type}">
              <img src="${lookupValue.image}" alt="${lookupValue.image_alt}">
            </div>
            <div class="find__storeDetailsProductName">${lookupValue.title}</div>
          </a>
        `;
        })
        .filter((brand) => brand != null).join('');
      const listItem = $(`<li class="find__listItem">
          <div class="find__listItemHeader" @click="expanded !== '${idx}' ? expanded = '${idx}' : expanded = null">
            <span>
              <div class="find__listTitle">${loc.dba}</div>
              <div class="find__list-address">${address}</div>
              <a href="tel:${loc.phoneFormatted}" class="find__listPhone">
                <img src="${findajarVars.phoneSvg}" />
                <span style="margin-left: 3px;">${loc.phoneFormatted}</span>
              </a>
              <div class="find__listDistance">
                <span>
                  ${parseFloat(loc.distance).toFixed(1)} Miles
                </span>
              </div>
            </span>
            <svg class="find__listItemHeaderExpandedIcon" :class="expanded === '${idx}' && '--isExpanded'" xmlns="http://www.w3.org/2000/svg" width="22px" viewBox="0 0 512 350"><path fill="currentColor" d="M239.029 300.477 44.686 106.133c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L256 203.506 410.745 49.485c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L272.97 300.476c-9.372 9.373-24.568 9.373-33.941.001Z"/></svg>
          </div>

          <div class="find__storeDetails" x-show="expanded === '${idx}'">
            <div class="find__storeDetailsActions">
              <a class="find__storeDetailsAction" target="_blank" href="${directionsUrl}">
                <svg xmlns="http://www.w3.org/2000/svg" width="19px" viewBox="0 0 512 512"><path fill="currentColor" d="M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"></path></svg>
                &nbsp;&nbsp;Directions
              </a>
              <button class="find__storeDetailsAction showOnMap" type="button" @click="if (window.innerWidth < 1024) { isShowList = false; }">
                <svg xmlns="http://www.w3.org/2000/svg" width="14px" viewBox="0 0 14 20"><path fill="currentColor" d="M9.492 7a2.492 2.492 0 1 1-4.985 0 2.492 2.492 0 0 1 4.985 0ZM7 0C3.13 0 0 3.13 0 7c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7Z"/></svg>
                &nbsp;&nbsp;View Map
              </button>
            </div>

            <div class="find__storeDetailsProducts">
              <div class="find__storeDetailsProductsHeader">
                <span>Recent Inventory</span>&nbsp;&nbsp;
                <span class="tooltip">
                  <span class="tooltip__text --top">Please call location to confirm availability first</span>
                </span>
              </div>
              <div class="find__storeDetailsProductsContainer">
                ${inventoryDetails}
              </div>
            </div>
          </div>
        </li>`).data('id', loc.id);
      $list.append(listItem);
    });

    $('.showOnMap').on('click', function() {
      const $this = $(this);
      const id = $this.parents('.find__listItem').data('id');
      const loc = locations.find((l) => {
        const locId = $('<div/>').data('id', l.id).data('id'); // deal with jquery escape stuff
        return locId === id;
      });
      const marker = markers.find(m => m.id === loc.id);
      renderInfoWindow({loc, marker});
      map.panTo(new google.maps.LatLng(loc.lat,loc.long));
      const address = `${loc.street}, ${loc.city}, ${loc.state} ${loc.zip}`;
      $('#find-search-location').val(address);
      window.history.replaceState(null, null, `/pages/find-a-jar?q=${address}&locationFilter=${$("#locationFilter").val()}`);
    });
  };

  const onLocationsUpdate = ({locations}) => {
    renderList({locations});
    zoomChangedEnabled = false;
    markers
      .filter((m) => !locations.map((l) => l.id).includes(m.id))
      .forEach((m) => m.setMap(null));
    const newMarkers = [];
    const bounds = new google.maps.LatLngBounds();
    (locations || []).forEach((loc, idx) => {
      let marker = markers.find((m) => m.id === loc.id);
      if (marker == null) {
        marker = new google.maps.Marker({
          position: new google.maps.LatLng(loc.lat, loc.long),
          map,
          title: loc.dba,
          icon: {
            url:
              loc.storeTypeRollup === 'on'
                ? findajarVars.onPremiseIconUrl
                : findajarVars.offPremiseIconUrl,
            anchor: new google.maps.Point(12, 24),
            strokeColor: 'black',
          },
          optimized: false,
        });
        marker.id = loc.id;
        marker.isOpen = false;

        marker.addListener('click', () => {
          if (marker.isOpen === true) {
            marker.isOpen = false;
            infowindow.close();
          } else {
            renderInfoWindow({loc, marker});
            const address = `${loc.street}, ${loc.city}, ${loc.state} ${loc.zip}`;
            window.history.replaceState(
              null,
              null,
              `/pages/find-a-jar?q=${address}&locationFilter=${$(
                '#locationFilter',
              ).val()}`,
            );
          }
        });
      }
      bounds.extend(marker.position);
      newMarkers.push(marker);
    });
    if (newMarkers.length > 0 && fitBounds) {
      map.fitBounds(bounds);
    }
    markers = [...newMarkers];

    setTimeout(() => {
      zoomChangedEnabled = true;
    }, 1000);
  };

  function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return phoneNumberString;
  }

  const renderInfoWindow = ({loc, marker}) => {
    markers.forEach((m) => (m.isOpen = false));
    const directionsUrl = `https://maps.google.com/?q=${encodeURIComponent(
      `${loc.street},${loc.city},${loc.state}`,
    )}`;
    marker.isOpen = true;
    infowindow.setContent(`
    <div style="padding:10px" class="find__infowindow"><h3 style="color: black; font-weight: bold">${
      loc.dba
    }</h3><p style="color: black; line-height: 30px; margin: 0;">
      <a target="_blank" style="line-height: 22px !important" href="${directionsUrl}">${
      loc.street
    }<br />${loc.city}, ${loc.state} ${loc.zip}</a><br />
      <img class="find__infowindow_icon" src="${
        findajarVars.phoneSvg
      }" />&nbsp;&nbsp;${formatPhoneNumber(loc.phone)}<br />
      <img class="find__infowindow_icon" src="${
        findajarVars.directionsSvg
      }" />&nbsp;&nbsp;<a target="_blank" href="${directionsUrl}"">Directions</a>
      </p></div>
    `);

    infowindow.open({
      anchor: marker,
      map,
      shouldFocus: false,
    });
  };

  const initMap = () => {
    map = new google.maps.Map(document.getElementById('find__map'), {
      center: {lat: -34.397, lng: 150.644},
      zoom: 8,
      fullscreenControl: true,
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
      scrollwheel: false,
      // zoomControl: false,
      // disableDoubleClickZoom: true,
      zoomControl: true,
      disableDefaultUI: true,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      gestureHandling: 'greedy',
      styles: [
        {
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#bdbdbd',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [
            {
              color: '#dadada',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5',
            },
          ],
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#c9c9c9',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
      ],
    });

    google.maps.event.addListenerOnce(map, 'idle', function() {
      // if query set, pass to reverse geolocation
      const query = qs('q');
      if (query !== '' && query != null) {
        $.ajax(`${window.moonshineApi}/geocode`, {
          data: JSON.stringify({address: query}),
          contentType: 'application/json',
          type: 'POST',
          success: function(response) {
            const gps = (
              (((response || {}).results || [])[0] || {}).geometry || {}
            ).location;
            if (gps) {
              coordinates = {longitude: gps.lng, latitude: gps.lat};
              onCoordinatesUpdated({
                coordinates: {
                  ...coordinates,
                  locationFilter: $('#locationFilter').val(),
                },
              });
            }
          },
          error: function(xhr, status, error) {
            console.error(error);
          },
        });
      } else {
        // otherwise autodetect user location
        geolocator.locate(
          {
            timeout: 5000,
            maximumWait: 10000,
            fallbackToIP: true,
            enableHighAccuracy: false,
          },
          (err, location) => {
            if (err) return console.log(err);
            console.log({detectUserLocation: location});
            coordinates = (location || {}).coords;
            const landmark = ((location || {}).address || {}).city;
            if (coordinates != null) {
              onCoordinatesUpdated({
                coordinates: {
                  ...coordinates,
                  locationFilter: $('#locationFilter').val(),
                },
              });
            }
            if (landmark != null) {
              $('#find-search-location').val(landmark);
            }
          },
        );
      }

      google.maps.event.addListener(map, 'dragend', () => {
        console.info('dragend');
        fitBounds = false;
        const center = map.getCenter();
        const bounds = map.getBounds();
        const cornerCoordinates = bounds.getNorthEast();
        const distanceMeters = google.maps.geometry.spherical.computeDistanceBetween(
          center,
          cornerCoordinates,
        );
        const distanceMiles = 0.000621371 * distanceMeters;
        coordinates = {
          latitude: center.lat(),
          longitude: center.lng(),
          distance: distanceMiles,
        };
        onCoordinatesUpdated({
          coordinates: {
            ...coordinates,
            locationFilter: $('#locationFilter').val(),
          },
        });
      });
      google.maps.event.addListener(map, 'zoom_changed', () => {
        // console.info("zoom_changed");
        if (zoomChangedEnabled) {
          const center = map.getCenter();
          const bounds = map.getBounds();
          const cornerCoordinates = bounds.getNorthEast();
          const distanceMeters = google.maps.geometry.spherical.computeDistanceBetween(
            center,
            cornerCoordinates,
          );
          const distanceMiles = 0.000621371 * distanceMeters;
          coordinates = {
            latitude: center.lat(),
            longitude: center.lng(),
            distance: distanceMiles,
          };
          onCoordinatesUpdated({
            coordinates: {
              ...coordinates,
              locationFilter: $('#locationFilter').val(),
            },
          });
        }
      });
    });
  };
  initMap();

  function initAutocomplete() {
    const options = {
      componentRestrictions: {country: 'us'},
    };
    const input = document.getElementById('find-search-location');
    const autocomplete = new google.maps.places.Autocomplete(input, options);

    autocomplete.addListener('place_changed', function() {
      var place = autocomplete.getPlace();

      if (place.length === 0) {
        return;
      }

      fitBounds = true;
      window.location =
        '/pages/find-a-jar?q=' +
        encodeURIComponent(input.value) +
        `&locationFilter=${$('#locationFilter').val()}`;
    });
  }
  initAutocomplete();
});
